import { generateTranslations } from '../../i18n/translation';

const namespace = 'myUsers';

const translations = generateTranslations(namespace, {
  headerEpost: {
    nb: 'Epostadresse',
    en: 'Email address',
  },
  headerEtternavn: {
    nb: 'Etternavn',
    en: 'Last name',
  },
  headerFornavn: {
    nb: 'Fornavn',
    en: 'Name',
  },
  pageSubtitle: {
    nb: 'Viser en liste over studiestedbrukere med samme feide id som systembrukeren din og en liste over praksisstedbrukere med samme fødselsnummer som systembrukeren din.',
    en: 'Shows a list of UH users that are connected to your feide id, as well as a list of PS users that have the same identity number as your admin user.',
  },
  pageTitle: {
    nb: 'Mine brukere',
    en: 'My users',
  },
  headerTilganger: {
    nb: 'Tilganger',
    en: 'Access',
  },
  headerHandlinger: {
    nb: 'Handlinger',
    en: 'Actions',
  },
  btnReset: {
    nb: 'Sett tilgang til toppnivå',
    en: 'Set access to top level',
  },
  btnDeaktiver: {
    nb: 'Deaktivér bruker',
    en: 'Deactivate user',
  },
  btnReaktiver: {
    nb: 'Reaktivér bruker',
    en: 'Activate user',
  },
  praksisstedbrukere: {
    nb: 'Praksisstedbrukere',
    en: 'Practice place users',
  },
  studiestedbrukere: {
    nb: 'Studiestedbrukere',
    en: 'Institution users',
  },
  success: {
    nb: 'Bruker oppdatert',
    en: 'User updated',
  },
});

export default translations;
